import { Modal, Tabs, Button } from "antd";
import styled from "styled-components";

export const StyledModal = styled(Modal)`
  .ant-modal-header {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #12619C;
    height: 61px;
  }

  .ant-modal-content {
    border-radius: 10px;
  }

  .ant-modal-body {
    padding: 0;
    max-height: calc(90vh - 108px);
    overflow-y: scroll;
  }

  .ant-modal-title {
    color: #fff;
    font-weight: bold;
  }

  .ant-modal-close-x {
    color: #fff;
  }
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Subtitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 500;
`;

export const StyledTabs = styled(Tabs)`
  padding-top: 16px;

  .ant-tabs-nav-list {
    margin: 0 auto;
  }
`;

export const CardTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  font-size: 18px;
  font-weight: 500;
`;

export const CardDescription = styled.p`
  font-size: 13px;
  color: #777;
  margin-bottom: 12px;
`;

export const ButtonStyled = styled(Button)`
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  float: right;
  background-color: #11a557;
  border: none;

  &:hover, &:active, &:focus {
    background-color: #0e8a47;
  }
`;

export const ButtonStyledLink = styled(Button)`
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  float: right;
  background-color: #f5f5f5;
  color: #666;
  border: 1px solid #ddd;

  &:hover, &:active, &:focus {
    color: #666;
    border: 1px solid #ddd;
    background-color: #e9ecef !important;
  }
`;

export const ContentButton = styled.div`
  display: flex;
  gap: 8px;
`;

export const FooterText = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  span {
    display: flex;
    align-items: center;
    gap: 4px;
    font-weight: bold;
    color: #f00;
  }
`;

export const FooterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
